import React, { useEffect, useState } from 'react';
import { Modal, Button, Row, Col, FormGroup, Input } from 'reactstrap';
import InputCustom from "@pages/components/InputCustom";
import {InputArraySelect, InputKeySelect} from "@pages/components/InputSelect";
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import CustomLabel from "@pages/components/CustomLabel";

export default function CreateTaskModal({
                                            addModal,
                                            setAddModal,
                                            initialTask,
                                            dealerMembers,
                                            editing,
                                            setEditing,
                                            addTask,
                                            updateTask,
                                            errors = {},
                                            statuses = [],
                                        }) {
    const [task, setTask] = useState({});

    useEffect(() => {
        if (initialTask) {
            setTask(initialTask);
        }
    }, [initialTask]);

    return (
        <Modal
            isOpen={addModal}
            toggle={() => setAddModal(false)}
            size="lg"
            className="modal-dialog-centered modal-secondary"
        >
            <div className="modal-body">
                <form className="new-event--form">
                    <InputCustom
                        newLabel={'Title'}
                        required
                        checkValid={false}
                        placeholder={'Title'}
                        value={task?.title || ''}
                        onChange={(e) =>
                            setTask({
                                ...task,
                                title: e.target.value,
                            })
                        }
                        invalid={!!errors.title}
                        errorMessage={'Title field is required.'}
                    />

                    <InputCustom
                        newLabel={'Description'}
                        required
                        checkValid={false}
                        placeholder={'Description'}
                        value={task?.comments || ''}
                        onChange={(e) =>
                            setTask({
                                ...task,
                                comments: e.target.value,
                            })
                        }
                        invalid={!!errors.comments}
                        errorMessage={'Description field is required.'}
                    />

                    <Row>
                        <Col sm={12}>
                            <FormGroup className="d-flex align-items-center">
                                <CustomLabel
                                    defaultLabel
                                    className="form-control-label w-50"
                                    text={'Due'}
                                />
                                <Input
                                    className="form-control-alternative new-event--title"
                                    type="date"
                                    onChange={(e) =>
                                        setTask({
                                            ...task,
                                            due_date: e.target.value,
                                        })
                                    }
                                    value={task?.due_date || ''}
                                    invalid={!!errors.due_date}
                                />
                                <div className="invalid-feedback">
                                    {errors.due_date}
                                </div>
                            </FormGroup>

                            <InputKeySelect
                                newLabel="Theme Type"
                                value={task?.status || ''}
                                options={statuses}
                                onChange={(e) =>
                                    setTask({
                                        ...task,
                                        status: e.target.value,
                                    })
                                }
                                defaultOption={true}
                            />

                            <FormGroup className="d-flex align-items-center">
                                <label className="form-control-label w-50">Assign to</label>
                                <div className="w-100">
                                    <InputArraySelect
                                        options={dealerMembers}
                                        multiple={true}
                                        value={task?.task_assignee || []}
                                        onChange={(e) =>
                                            setTask({
                                                ...task,
                                                task_assignee: e.target.value,
                                            })
                                        }
                                        valueKey="id"
                                        labelKey="text"
                                    />
                                </div>
                                {errors?.task_assignee && (
                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                        {errors.task_assignee}
                                    </div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                </form>
            </div>
            <div className="modal-footer justify-content-end">
                <Button
                    onClick={() => {
                        if (editing) {
                            setTask({});
                            setEditing(false);
                        }
                        setAddModal(false);
                    }}
                >
                    Cancel
                </Button>

                {editing ? (
                    <ButtonContainer reverse onClick={()=>{updateTask(task)}}>
                        Update
                    </ButtonContainer>
                ) : (
                    <ButtonContainer reverse onClick={()=>{addTask(task)}}>
                        Save
                    </ButtonContainer>
                )}
            </div>
        </Modal>
    );
}
